"use client";
import { jsxs as l, jsx as x } from "react/jsx-runtime";
import { cva as d } from "class-variance-authority";
import { forwardRef as A, useState as T, useRef as I, useEffect as L } from "react";
import { getFocusWithinAccessibleStyles as W } from "../../../utils/styles.mjs";
import { Text as g } from "../Text/Text.mjs";
import { cn as r } from "../../../utils/utils.mjs";
const j = d(
  `
    group
    w-full
    flex
    flex-col
    min-h-0
    p-2
    gap-3
    rounded-md
    
    bg-white
    
    dark:bg-neutral-dark-200
    `,
  {
    variants: {
      state: {
        default: "",
        error: "border border-red-400"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), D = d(
  `
    block
    w-full
    field-sizing-content
    overflow-y-auto

    disabled:cursor-not-allowed
    disabled:opacity-60
    min-h-[94px] 
    min-w-[240px]
    text-xs
    leading-[var(--text-xs--line-height)]

    bg-inherit
    text-gray-900 
    placeholder:text-gray-500 

    dark:bg-inherit
    dark:text-neutral-dark-1000
    dark:placeholder:text-neutral-dark-600
    `,
  {
    variants: {
      resize: {
        vertical: "resize-y",
        horizontal: "resize-x",
        all: "resize",
        none: "resize-none"
      }
    },
    defaultVariants: {
      resize: "vertical"
    }
  }
), C = d("", {
  variants: {
    state: {
      default: "dark:text-neutral-dark-600",
      error: "text-red-100"
    }
  },
  defaultVariants: {
    state: "default"
  }
}), K = A(
  ({
    className: h,
    wrapperClassName: p,
    textAreaClassName: v,
    state: c = "default",
    resize: b = "vertical",
    showCount: w = !1,
    keyboardFocusOnly: t = !1,
    helperText: u = "",
    maxLength: n,
    onFocus: i,
    onBlur: a,
    value: s,
    ...k
  }, z) => {
    const [N, f] = T(!1), o = I("mouse"), S = s ? String(s).length : 0;
    L(() => {
      if (!t) return;
      const e = () => {
        o.current = "mouse";
      }, m = (R) => {
        R.key === "Tab" && (o.current = "keyboard");
      };
      return document.addEventListener("mousedown", e), document.addEventListener("keydown", m), () => {
        document.removeEventListener("mousedown", e), document.removeEventListener("keydown", m);
      };
    }, [t]);
    const V = (e) => {
      i == null || i(e), t && o.current === "keyboard" && f(!0);
    }, y = (e) => {
      a == null || a(e), t && f(!1);
    }, E = t ? r(
      "focus:outline-none focus:ring-0 focus:border-none",
      "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none",
      N && "!outline-solid !outline-2 !outline-offset-2 !outline-white !ring-2 !ring-blue-600"
    ) : W();
    return /* @__PURE__ */ l("div", { className: r("flex flex-col gap-2 min-h-0", p), children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: r(j({ state: c }), E, h),
          "data-testid": "text-area-input-container",
          children: [
            /* @__PURE__ */ x(
              "textarea",
              {
                ref: z,
                className: r(
                  D({ resize: b }),
                  "focus:outline-none focus:ring-0 focus:border-none",
                  "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none",
                  v
                ),
                onFocus: V,
                onBlur: y,
                maxLength: n,
                value: s,
                ...k
              }
            ),
            w && n && /* @__PURE__ */ l(g, { fontSize: "xs", fontWeight: "regular", className: "dark:text-neutral-dark-600 text-right pr-2", children: [
              S,
              "/",
              n,
              " characters"
            ] })
          ]
        }
      ),
      u && /* @__PURE__ */ x(g, { fontSize: "xs", fontWeight: "regular", className: C({ state: c }), children: u })
    ] });
  }
);
K.displayName = "TextAreaInput";
export {
  K as TextAreaInput
};
